import axios from '@axios'

const PREFIX = '/empresas'

export default {

  getEmpresasResumidas(filtro) {
    return axios.post(`${PREFIX}/resumido`, filtro)
  },

  getEmpresas(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getEmpresa(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateEmpresa(id, empresa) {
    return axios.put(`${PREFIX}/${id}`, empresa)
  },

  createEmpresa(empresa) {
    return axios.post(`${PREFIX}/add`, empresa)
  },

  delete(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  deleteAll(idList) {
    return axios.delete(`${PREFIX}/lote`, { data: idList })
  },

  getEmpresasPorModelo(id) {
    return axios.get(`${PREFIX}/empresas-modelo/${id}`)
  },

  existeEmpresaComModelo(modeloId) {
    return axios.get(`${PREFIX}/existe-empresa/${modeloId}`)
  },

  getInformacaoEmpresa(cnpjEmpresa) {
    return axios.post(`${PREFIX}/busca-cnpj?cnpjEmpresa=${cnpjEmpresa}`)
  },

  getUsuariosInativos(id) {
    return axios.get(`${PREFIX}/usuarios-inativos/${id}`)
  },

  trocarResponsavel(responsavelTroca) {
    return axios.post(`${PREFIX}/troca-responsavel`, responsavelTroca)
  },

  existeInscricao(cadastroFederal, id) {
    return axios.get(`${PREFIX}/cadastro-federal?id=${id}&cadastroFederal=${cadastroFederal}`)
  },

  cadastroEmpresaProposta(idProposta) {
    return axios.put(`${PREFIX}/cadastro-empresa-proposta?id=${idProposta}`)
  },

  cadastroEmpresaPropostaPortal(idProposta) {
    return axios.put(`${PREFIX}/portal-propostas/cadastro-empresa-proposta?id=${idProposta}`)
  },

  replicarConfiguracaoModelo(id, form) {
    return axios.post(`${PREFIX}/replica-configuracao/empresa/${id}`, form)
  },

  validaCertificado(form) {
    return axios.post(`${PREFIX}/valida-certificado`, form)
  },

  getArquivoContratual(id, tipo) {
    return axios.get(`${PREFIX}/${id}/arquivo-contratual?tipo=${tipo}`)
  },

  getHistoricosEmpresa(id) {
    return axios.get(`${PREFIX}/historicos-empresa/${id}`)
  },

  getPropostasVinculadas(id, page, pageSize) {
    return axios.get(`${PREFIX}/${id}/propostas?page=${page}&pageSize=${pageSize}`)
  },
}
